import { Injectable } from "@angular/core";
import { CanLoad, Route, Router, UrlSegment } from "@angular/router";
import { ACL } from "app/shared/models/acl";
import { Observable } from "rxjs";
import { AuthService } from "../services/admin/auth/auth.service";

@Injectable()
export class UploadModuleGuard implements CanLoad {
    constructor(private _authService: AuthService, private _router: Router) {}

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        const acl: ACL = this._authService.getUserAclFromToken();

        let result;
        if (acl.SYSPAD_DAM_MEDIA_CREATE) {
            result = true;
        } else {
            result = this._router.parseUrl("/");
        }

        return result;
    }
}
